import React from 'react';

const LoadingSpinner = ({ 
  message = "Chargement...", 
  size = "md", 
  color = "#246990",
  fullHeight = false 
}) => {
  // Tailles prédéfinies
  const sizes = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16"
  };

  const containerHeight = fullHeight ? "h-screen" : "h-40";

  return (
    <div className={`flex flex-col items-center justify-center ${containerHeight}`}>
      <div 
        className={`animate-spin rounded-full border-t-2 border-b-2 ${sizes[size]}`}
        style={{ borderColor: color }}
      />
      {message && (
        <p className="mt-3 text-gray-600 font-medium">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;